import mitt from 'mitt';
import type { EventEmitter, Events } from '@hotjar/navigation/src/types';

export const createEmitter = (emitter?: EventEmitter): EventEmitter => emitter ?? mitt<Events>();
